import AirportList from "airport/AirportList";
import AirportDetailApp from "airport/Detail/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const airportRoute: RouteObject = {
  path: "airport",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: AirportList,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: AirportDetailApp,
  }]
};